/**
 * The one-line result of an action -- "Marked for review", or the exact reason
 * the database refused.
 *
 * Not a toast that fades: BRAND.md §7 wants a stated consequence, and a
 * rejected transition is something a person needs to read, not catch. It stays
 * until the next action replaces it or the reader dismisses it.
 */

import type { Tone } from '../status'
import { TONE_CLASSES } from '../status'

export interface NoticeState {
  tone: Tone
  message: string
}

export function Notice({ notice, onDismiss }: { notice: NoticeState; onDismiss: () => void }) {
  return (
    <div
      role="status"
      className={[
        'mb-4 flex items-start justify-between gap-4 rounded-eq-md px-4 py-3 text-[14px]',
        TONE_CLASSES[notice.tone],
      ].join(' ')}
    >
      <span>{notice.message}</span>
      <button
        type="button"
        onClick={onDismiss}
        className="font-heading text-[12px] font-bold underline"
      >
        Dismiss
      </button>
    </div>
  )
}
